module.exports = __webpack_public_path__ + "media/images/small-world-7a86b7e81494507ebb6251934f9cd91b.png";